import {isEmpty} from "lodash";
import {dateToString} from "./DateUtils";

export const getContentDispositionFilename = (headers) => {
  const contentDisposition = headers['content-disposition'];
  if (isEmpty(contentDisposition) || contentDisposition.indexOf('attachment') === -1) {
    return "export_" + dateToString(new Date(), false, true).replaceAll(" ", "_") + ".xlsx";
  } else {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(contentDisposition);
    if (matches != null && matches[1]) {
      return matches[1].replace(/['"]/g, '');
    }
  }
}
